const CRM_API_URL = "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata";

const getIpAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    return (await response.json()).ip || "";
  } catch {
    return "";
  }
};

export const submitInsuranceLead = async ({ formData, vertical, formname }) => {
  const ipAddress = await getIpAddress();
  const params = new URLSearchParams(window.location.search);
  const submittedAt = new Date().toISOString();
  const submissionDateCST = new Date().toLocaleString("en-US", { timeZone: "America/Chicago", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true }) + " CST";
  const answerValues = Object.values(formData.answers);
  const data = {
    name: formData.fullName,
    firstName: formData.fullName.trim().split(" ")[0] || "",
    lastName: formData.fullName.trim().split(" ").slice(1).join(" "),
    fullName: formData.fullName,
    phone: `+1${formData.phone.replace(/\D/g, "")}`,
    email: formData.email,
    state: formData.state,
    consent: formData.consent,
    consentgiven: formData.consent,
    answers: formData.answers,
    q1: answerValues[0] || "",
    q2: answerValues[1] || "",
    q3: answerValues[2] || "",
    q4: answerValues[3] || "",
    q5: answerValues[4] || "",
    q6: answerValues[5] || "",
    q7: answerValues[6] || "",
    pageSource: window.location.href,
    submissionDate: submittedAt,
    submissionDateCST,
    localTime: new Date().toString(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ipAddress,
    trustedFormCertUrl: formData.certId || "",
    trustedFormPingUrl: formData.pingUrl || "",
    trustedFormToken: formData.tokenUrl || "",
    certId: formData.certId || "",
    pingUrl: formData.pingUrl || "",
    tokenUrl: formData.tokenUrl || "",
    gclid: params.get("gclid") || "",
    gbraid: params.get("gbraid") || "",
    wbraid: params.get("wbraid") || "",
    ...formData.answers,
  };

  try {
    const response = await fetch(CRM_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        countryName: "USA",
        brandType: "Internal",
        brandName: "Project 6",
        websiteName: "Be With Law",
        formPath: window.location.pathname,
        vertical,
        formname,
        finalSubmit: true,
        deleteFromWebsiteLogs: true,
        data,
      }),
    });

    if (!response.ok) {
      console.error("CRM submission failed; continuing form submission.", await response.text());
    }
  } catch (error) {
    console.error("CRM submission failed; continuing form submission.", error);
  }

  return { ...data, ipAddress, formname };
};
